import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import HoverTooltip from '@Components/HoverTooltip';
import { TooltipConstants } from '@Components/Tooltip';

// eslint-disable-next-line react/function-component-definition
const ReactionTransferTo = ({ onClick }) => (
  <span className="reactions-item-connector--transfer-to u-els-font-size-base">
    <HoverTooltip id={TooltipConstants.ids.GlobalHover} tooltip="Transfer to retrosynthesis">
      <Button
        buttonConfig={{ type: 'link', iconOnly: true, size: 'sm', e2eName: 'reactions-transfer-to' }}
        iconConfig={{ name: 'synthesize' }}
        onClick={onClick}
        aria-label="Transfer to retrosynthesis"
      />
    </HoverTooltip>
  </span>
);

ReactionTransferTo.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ReactionTransferTo;
